// @figma file=pkCGby54zXzTsccXvHqzO6 node=tbd name="BlockHeading" set="mytaible-shadcn-studio" verified=tbd

import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../../lib/utils';

// ─── Variants ─────────────────────────────────────────────────────────────────

const blockHeadingVariants = cva('flex flex-col gap-2', {
  variants: {
    align: {
      left: 'items-start text-left',
      center: 'items-center text-center',
    },
  },
  defaultVariants: {
    align: 'left',
  },
});

// ─── Props ────────────────────────────────────────────────────────────────────

export interface BlockHeadingProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof blockHeadingVariants> {
  heading: string;
  subtitle?: string;
  hasSubtitle?: boolean;
  hasCta?: boolean;
  cta?: React.ReactNode;
}

// ─── Component ────────────────────────────────────────────────────────────────

const BlockHeading = React.forwardRef<HTMLDivElement, BlockHeadingProps>(
  (
    { className, heading, subtitle, hasSubtitle = true, hasCta = false, cta, align, ...props },
    ref,
  ) => (
    <div ref={ref} className={cn(blockHeadingVariants({ align }), className)} {...props}>
      <h2 className="text-2xl font-semibold leading-tight tracking-tight text-foreground">
        {heading}
      </h2>
      {hasSubtitle && subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
      {hasCta && cta && <div className="mt-1">{cta}</div>}
    </div>
  ),
);
BlockHeading.displayName = 'BlockHeading';

export { BlockHeading, blockHeadingVariants };
